import { Typeaheads as CommonTypeaheads } from '../../common/helpers/api-client/Typeaheads'

export class Typeaheads extends CommonTypeaheads {
}
